var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 86.383,
    viewBox: "0 0 128 86.383",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11144",
    "data-name": "Group 11144",
    transform: "translate(654.45 15692.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M213.82,107.347H138.927V121.12H108.381L94.242,145.446v35.505h11.294a16.969,16.969,0,0,0,32.886,0h38.155a16.968,16.968,0,0,0,32.885,0h12.778v-73.6ZM113.23,129.528h25.7v13.059H105.649Zm-10.579,21.424h36.276v21.593h-.5a16.968,16.968,0,0,0-32.886,0H102.65Zm19.337,34.372a3.555,3.555,0,1,1,0,.014Zm71.025,0a3.555,3.555,0,1,1,0,.014Zm16.436-12.778a16.968,16.968,0,0,0-32.886,0H147.335V115.755h66.486v56.791Z",
    transform: "translate(-748.692 -15800.344)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6134",
    "data-name": "Path 6134",
    d: "M343.67,232.4h43.9v8.408h-43.9Z",
    transform: "translate(-935.71 -15894.106)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6135",
    "data-name": "Path 6135",
    d: "M343.67,288.4h14.475v8.408H343.67Z",
    transform: "translate(-935.711 -15936.093)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6136",
    "data-name": "Path 6136",
    d: "M343.67,176.4h29.888v8.408H343.67Z",
    transform: "translate(-935.71 -15852.121)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/Road.f1f70925f9542c56945038f8d7475a67.svg";
export { ForwardRef as ReactComponent };